import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// YouTube embeds and aspect-ratio layouts can trigger this benign browser warning.
const RESIZE_OBSERVER_LOOP_ERROR = 'ResizeObserver loop completed with undelivered notifications.';
const RESIZE_OBSERVER_LIMIT_ERROR = 'ResizeObserver loop limit exceeded';

window.addEventListener(
  'error',
  (event) => {
    if (
      event.message === RESIZE_OBSERVER_LOOP_ERROR ||
      event.message === RESIZE_OBSERVER_LIMIT_ERROR
    ) {
      event.stopImmediatePropagation();
    }
  },
  true
);

// Import global styles
import './styles/variables.css';
import './styles/globals.css';
import './styles/themes.css';
import './styles/utilities.css';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    if (process.env.NODE_ENV === 'production') {
      navigator.serviceWorker.register('/sw.js').catch((error) => {
        console.warn('Service worker registration failed:', error);
      });
      return;
    }

    // Prevent stale SW/cache behavior during local development.
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
      .catch((error) => {
        console.warn('Service worker cleanup failed:', error);
      });

    if ('caches' in window) {
      caches.keys()
        .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
        .catch((error) => {
          console.warn('Cache cleanup failed:', error);
        });
    }
  });
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(<App />);
